/* worldie — adventure club sign-up (snippets/ac-signup.liquid), WOR-64.

   One script for every instance on the page (the snippet may render more than
   once: hero + footer). Loaded with `defer`; the guard below makes a second
   <script> tag for the same file a no-op.

   1. On submit, remember which instance posted (sessionStorage) so the reply
      can be matched even if the hash is lost on the way back.
   2. After Shopify's redirect (return_to = path?customer_posted=true#id, or a
      re-render with form errors), reveal the success / error message in ONE
      instance only: the one named in location.hash, else the one stored at
      submit, else the first on the page. Every other instance stays quiet,
      because Liquid's form.posted_successfully? is true in all of them at
      once. Fallback: if the server flag is missing but the hash names the
      instance stored at submit (within 15 minutes) and there is no error,
      treat it as a post anyway (Shopify honours return_to verbatim, so the
      query could be stripped by a future change without warning).
   3. Send `ac_list_signup { placement }` exactly once through
      window.WorldieTrack (snippets/wd-track: Shopify.analytics.publish + the
      Google channel's gtag, queued until gtag exists; at DOMContentLoaded it
      usually doesn't yet, which is why sign-ups went missing in GA4 before
      2026-10-19), then strip customer_posted from the URL so a reload cannot
      publish again.
      `placement` is the form's own data attribute, never a query parameter;
      WOR-81's notify flow may override it via sessionStorage (`notify`).
      No email, no customer id, nothing else goes in the payload.
   4. WOR-145, one "already signed up" state with Ryan's Klaviyo popup:
      - on submit, identify the typed address to Klaviyo (klaviyo.identify),
        so the popup's "existing profile" rule stops showing it to this
        browser. The address goes to Klaviyo only; nothing here keeps it.
        Best effort: the page navigates right away.
      - after a successful post, set the shared flag (WorldieAcState.mark,
        assets/ac-state.js: localStorage `wd_ac_in` = a timestamp) so every
        other sign-up block on this and later pages swaps to "you're in".
        The surface holding this instance keeps its success line
        (data-ac-keep). */
(function () {
  'use strict';
  if (window.__acSignupLoaded) return;
  window.__acSignupLoaded = true;

  var EVENT = 'ac_list_signup';
  var KEY_ID = 'ac_signup_id';
  var KEY_FROM = 'ac_signup_from';
  var ALLOWED_FROM = { notify: true };

  var KEY_AT = 'ac_signup_at';
  var FRESH_MS = 15 * 60 * 1000;

  function store(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function clear(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function fresh() {
    var at = parseInt(read(KEY_AT) || '0', 10);
    return at > 0 && Date.now() - at < FRESH_MS;
  }

  function emit(payload) {
    if (window.WorldieTrack) window.WorldieTrack.emit(EVENT, payload);
  }

  function identify(form) {
    try {
      var input = form.querySelector('input[type="email"]');
      var email = input && input.value ? input.value.trim() : '';
      if (!email || email.indexOf('@') < 1) return;
      // pre-fill Shopify's sign-in page later (ac-state.js, this browser only)
      if (window.WorldieAcState && typeof window.WorldieAcState.rememberEmail === 'function') window.WorldieAcState.rememberEmail(email);
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        var done = window.klaviyo.identify({ email: email });
        if (done && typeof done.catch === 'function') done.catch(function () {});
      }
    } catch (e) {}
  }

  function markSignedUp(root) {
    try {
      var surface = root.closest('[data-ac-surface]');
      if (surface) surface.setAttribute('data-ac-keep', '');
    } catch (e) {}
    if (window.WorldieAcState && typeof window.WorldieAcState.mark === 'function') {
      window.WorldieAcState.mark();
      return;
    }
    try { window.localStorage.setItem('wd_ac_in', String(Date.now())); } catch (e) {}
    document.documentElement.classList.add('wd-ac-in');
  }

  function instances() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-ac-signup]'));
  }

  function pick(list) {
    var hash = (location.hash || '').replace(/^#/, '');
    var i;
    if (hash) {
      for (i = 0; i < list.length; i++) {
        var f = list[i].querySelector('form');
        if (f && f.id === hash) return list[i];
      }
    }
    var stored = read(KEY_ID);
    if (stored) {
      for (i = 0; i < list.length; i++) {
        var g = list[i].querySelector('form');
        if (g && g.id === stored) return list[i];
      }
    }
    return list[0] || null;
  }

  function stripPosted() {
    try {
      var url = new URL(location.href);
      if (!url.searchParams.has('customer_posted')) return;
      url.searchParams.delete('customer_posted');
      history.replaceState(history.state, '', url.pathname + (url.search || '') + (url.hash || ''));
    } catch (e) {}
  }

  function init() {
    var list = instances();
    if (!list.length) return;

    list.forEach(function (root) {
      var form = root.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', function () {
        identify(form);
        store(KEY_ID, form.id);
        store(KEY_AT, String(Date.now()));
        // WOR-81: arrived from the PDP's sold-out button -> placement `notify`
        try {
          var from = new URLSearchParams(location.search).get('from');
          if (from && ALLOWED_FROM[from]) store(KEY_FROM, from);
        } catch (e) {}
      });
    });

    var errored = list.some(function (r) { return r.querySelector('[data-ac-error]'); });
    var posted = list.some(function (r) { return r.querySelector('[data-ac-posted]'); });
    var target = pick(list);
    if (!target) return;
    if (!posted && !errored) {
      // client-side fallback: back from a submit, the hash names the same
      // instance, nothing went wrong -> the post succeeded
      var f = target.querySelector('form');
      var hash = (location.hash || '').replace(/^#/, '');
      if (!(f && hash && f.id === hash && read(KEY_ID) === f.id && fresh())) return;
      posted = true;
    }

    if (posted) {
      var ok = target.querySelector('[data-ac-success]');
      if (ok) {
        ok.hidden = false;
        target.classList.add('is-posted');
        try { ok.focus && ok.setAttribute('tabindex', '-1'); ok.focus(); } catch (e) {}
      }
      var placement = target.getAttribute('data-ac-placement') || 'page';
      var from = read(KEY_FROM);
      if (from && ALLOWED_FROM[from]) placement = from;
      emit({ placement: placement });
      markSignedUp(target);
      stripPosted();
    } else {
      var err = target.querySelector('[data-ac-error]');
      if (err) err.hidden = false;
    }

    clear(KEY_ID);
    clear(KEY_AT);
    clear(KEY_FROM);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
